<template>
  <div id="streetViewContainer">
    <div class="wrapper" v-show="streetViewSrc2 && c2SuccessfulLoad">
      <div
        id="streetViewTop"
        class="box"
        @click="openImgInNewTab('ushrStreetViewC2')"
      >
        <h5 class="image-text top-left-text unselectable">
          {{ ushrImageryAttributeData.datetime }}
        </h5>
        <h5 class="image-text top-right-text unselectable">C2</h5>
        <h5 class="image-text bottom-right-text unselectable">
          {{ ushrImageryAttributeData.processing_index }}
        </h5>
        <img
          id="ushrStreetViewC2"
          :src="streetViewSrc2"
          class="clickable"
          alt="C2"
          :height="bImg2Height"
          :width="bImg2Width"
          @load="imageFound(2)"
        />
      </div>
      <div id="imageryRotateDiv2" class="imageryRotateDiv">
        <button
          id="imageryRotateButton2"
          class="imageryRotateButton"
          size="sm"
          title="Rotate image clockwise"
          @click="imageRotate('ushrStreetViewC2')"
        >
          <span><fa :icon="['fas', 'sync-alt']" style="color: white;" /></span>
        </button>
      </div>
    </div>
    <div class="wrapper" v-show="streetViewSrc1 && c1SuccessfulLoad">
      <div
        id="streetViewBottom"
        class="box"
        @click="openImgInNewTab('ushrStreetViewC1')"
      >
        <h5 class="image-text top-left-text unselectable">
          {{ ushrImageryAttributeData.datetime }}
        </h5>
        <h5 class="image-text top-right-text unselectable">C1</h5>
        <h5 class="image-text bottom-right-text unselectable">
          {{ ushrImageryAttributeData.processing_index }}
        </h5>
        <img
          id="ushrStreetViewC1"
          :src="streetViewSrc1"
          class="clickable"
          alt="C1"
          :height="bImg1Height"
          :width="bImg1Width"
          @load="imageFound(1)"
        />
      </div>
      <div id="imageryRotateDiv1" class="imageryRotateDiv">
        <button
          id="imageryRotateButton1"
          class="imageryRotateButton"
          size="sm"
          title="image rotate"
          @click="imageRotate('ushrStreetViewC1')"
        >
          <span><fa :icon="['fas', 'sync-alt']" style="color: white;" /></span>
        </button>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ---------- Overlay label badges ---------- */
.image-text {
  position: absolute;
  z-index: 100;
  margin: 0;
  padding: 3px 10px;
  font-size: 0.78rem;
  font-weight: 600;
  line-height: 1.4;
  letter-spacing: 0.02em;
  color: #fff;
  background: rgba(15, 23, 42, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 999px;
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.25);
}

.top-left-text {
  top: 10px;
  left: 10px;
}

.top-right-text {
  top: 10px;
  right: 10px;
}

.bottom-right-text {
  bottom: 10px;
  right: 10px;
}

.unselectable {
  -moz-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* ---------- Layout containers ---------- */
#streetViewContainer {
  position: relative;
  text-align: center;
}

#streetViewBottom,
#streetViewTop {
  position: relative;
}

.wrapper {
  position: relative;
  height: 20rem;
  width: 30rem;
  margin-bottom: 0.25rem;
  border-radius: 14px;
  overflow: hidden;
  background: linear-gradient(
    145deg,
    rgba(6, 47, 86, 0.75),
    rgba(3, 26, 48, 0.75)
  );
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.35),
    inset 0 0 0 1px rgba(255, 255, 255, 0.06);
}

.box {
  border: none;
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: #1b1c1d;
  cursor: pointer;
}

.box img {
  width: 100%;
  height: 100%;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.portrait {
  padding-left: 17%;
  padding-right: 17%;
}

/* ---------- Rotate control ---------- */
.imageryRotateDiv {
  position: relative;
  z-index: 999;
  text-align: end;
  margin-top: -17rem;
  margin-right: 0.75rem;
}

.imageryRotateButton {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 2.25rem;
  height: 2.25rem;
  margin-top: -2em;
  padding: 0;
  font-size: 0.9rem;
  color: #fff;
  cursor: pointer;
  background: rgba(20, 22, 28, 0.45);
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 50%;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.35);
  transition: transform 0.25s ease, background 0.25s ease,
    box-shadow 0.25s ease, border-color 0.25s ease;
}

.imageryRotateButton:hover {
  background: rgba(37, 99, 235, 0.85);
  border-color: rgba(147, 197, 253, 0.6);
  box-shadow: 0 6px 18px rgba(37, 99, 235, 0.45);
  transform: scale(1.08);
}

.imageryRotateButton:active {
  transform: scale(0.94);
}

.imageryRotateButton span {
  display: inline-flex;
  transition: transform 0.4s ease;
}

.imageryRotateButton:hover span {
  transform: rotate(90deg);
}
</style>

<script>
export default {
  name: 'MMP_ANSI_UshrStreetView',
  props: ['streetViewSrc1', 'streetViewSrc2', 'ushrImageryAttributeData'],
  data() {
    return {
      bImg1Height: 350,
      bImg1Width: 500,
      bImg2Height: 350,
      bImg2Width: 500,
      originalRatio: 0.6666666666666666,
      c1SuccessfulLoad: false,
      c2SuccessfulLoad: false,
      streetViewChange: [false, false],
      ushrStreetViewC1Obj: {
        rotated: false,
        rotationAngle: 0,
      },
      ushrStreetViewC2Obj: {
        rotated: false,
        rotationAngle: 0,
      },
    }
  },
  methods: {
    imageFound(img) {
      if (img == 1) {
        this.c1SuccessfulLoad = true
        this.processDimensions(1)
      }
      if (img == 2) {
        this.c2SuccessfulLoad = true
        this.processDimensions(2)
      }
      this.$forceUpdate()
    },
    openImgInNewTab(imageId) {
      var imageObj = document.getElementById(imageId)
      var url = imageObj.src
      var rotationAngle = ''

      if (imageId == 'ushrStreetViewC1') {
        rotationAngle = this.ushrStreetViewC1Obj.rotationAngle
      } else {
        rotationAngle = this.ushrStreetViewC2Obj.rotationAngle
      }

      var conditionalClass =
        rotationAngle == 90 || rotationAngle == 270
          ? `<div class="box portrait">`
          : `<div class="box">`

      const htmlContent =
        `
      <!DOCTYPE html>
      <html lang="en">
      <head>
        <meta charset="UTF-8">
        <meta name="viewport" content="width=device-width, initial-scale=1.0">
        <title>Rotated Image</title>
        <style>
          body {
            margin: 1px;
            position: fixed;
            display: block;
            justify-content: center;
            align-items: center;
            height: 100%;
            width: 100%;
            overflow: hidden;
          }
          .wrapper {
              height: 100%;
              width: 100%;
              margin-bottom: 5px;
              background: rgba(6, 47, 86, 0.65);
              overflow: hidden;
            }

            .box {
              border: none;
              position: relative;
              width: 100%;
              height: 100%;
              overflow: hidden;
              color: #1b1c1d;
            }

            .portrait {
              position: fixed;
              padding-left: 30%;
              max-width: 47%;
              max-height: 100%;
              object-fit: cover;
            }

          img {
            height: 100%;
            width: 100%;
            transform: rotate(${rotationAngle}deg);
            overflow-clip-margin: content-box;
            overflow: hidden;
          }
        </style>
      </head>
      <body>
        <div class="wrapper">` +
        conditionalClass +
        ` <img src="${url}" alt="Rotated Image">
          </div>
        </div>
      </body>
      </html>
      `

      const newTab = window.open()
      newTab.document.open()
      newTab.document.write(htmlContent)
      newTab.document.close()
    },
    // REFACTOR SUGGESTION: fn not used and url is never defined...? Adding it as a parameter to get test cases to pass
    openCanvasImage(url) {
      if (document.getElementById("newImg")) {
        document.body.removeChild("newImg")
      }

      window.open(url, '_blank')
    },
    processDimensions(imgNum) {
      let id = 'ushrStreetViewC' + imgNum
      let element = document.getElementById(id)
      let originalHeight = element.naturalHeight
      let originalWidth = element.naturalWidth
      let divisor = originalHeight > 1080 && originalWidth > 1920 ? 6 : 4
      let scaledHeight = originalHeight / divisor
      let scaledWidth = originalWidth / divisor

      switch (imgNum) {
        case 1:
          this.bImg1Height = scaledHeight
          this.bImg1Width = scaledWidth
          break
        case 2:
          this.bImg2Height = scaledHeight
          this.bImg2Width = scaledWidth
          break
      }
    },
    imageRotate(imageId) {
      // Access DOM element object
      const rotated = document.getElementById(imageId)

      if (imageId == 'ushrStreetViewC2') {
        this.rotateImage(rotated, this.ushrStreetViewC2Obj)
      } else {
        this.rotateImage(rotated, this.ushrStreetViewC1Obj)
      }
    },
    rotateImage(rotated, imageRotationObject) {
      // How much to rotate the image at a time
      const angle = 90
      // Ensure angle range of 0 to 359 with "%" operator,
      // e.g., 450 -> 90, 360 -> 0, 540 -> 180, etc.
      imageRotationObject.rotationAngle =
        (imageRotationObject.rotationAngle + angle) % 360
      rotated.style.transform = `rotate(${imageRotationObject.rotationAngle}deg)`

      var rotationRatio =
        rotated.getBoundingClientRect().height /
        rotated.getBoundingClientRect().width

      if (rotationRatio > this.originalRatio) {
        rotated.classList.add("portrait")
      } else {
        rotated.classList.remove("portrait")
      }
    },
  },
  updated() {
    let changed = this.streetViewChange[0] || this.streetViewChange[1]
    this.streetViewChange[0] = this.streetViewChange[0] ? false : true
    this.streetViewChange[1] = this.streetViewChange[1] ? false : true
    if (changed) {
      this.$emit(
        'streetViewChanged',
        `width: ${Math.max(this.bImg1Width, this.bImg2Width)}px;
        height: ${Math.max(this.bImg1Height, this.bImg2Height)}px;`
      )
    }
  },
  watch: {
    streetViewSrc1: function (newValue, oldValue) {
      if (!newValue) {
        this.bImg1Height = 350
        this.bImg1Width = 500
      } else {
        this.c1SuccessfulLoad = false
        this.streetViewChange[0] = true
        this.processDimensions(1)
      }
    },
    streetViewSrc2: function (newValue, oldValue) {
      if (!newValue) {
        this.bImg2Height = 350
        this.bImg2Width = 500
      } else {
        this.c2SuccessfulLoad = false
        this.streetViewChange[1] = true
        this.processDimensions(2)
      }
    },
  },
}
</script>
